import axios from 'axios'
import { API_ENDPOINT } from '../../../config'
import store from '../../../redux/stores/store'
import Validation from '../../../data/validation/validation'
import { StringValidationRule } from '../../../data/validation/rules'

const getDefaultState = () => {
    return {
        saving: false,
        currentPassword: "",
        password: "",
        confirmPassword: "",
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.currentPassword, (error) => errors.currentPassword = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.password, (error) => errors.password = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Too long" } })
    let valid = validation.validate()

    if (instance.state.password !== instance.state.confirmPassword) {
        errors.confirmPassword = "Passwords do not match"
        valid = false
    }
    else {
        errors.confirmPassword = ""
    }

    instance.setState({
        ...instance.state,
        errors: errors,
        flag: {
            type: valid ? "" : "error",
            text: valid ? "" : "Validation Failure"
        }
    })

    return valid
}

const changePassword = (instance) => {
    instance.setState({
        ...instance.state,
        saving: true
    })

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/auth/change-password",
        headers: {
            "Authorization": store.getState().auth.authorizationToken
        },
        data: {
            currentPassword: instance.state.currentPassword,
            password: instance.state.password
        }
    }).then(response => {
        handleChangePasswordResponse(instance, response)
    }).catch(error => {
        instance.setState({
            ...instance.state,
            saving: false,
            flag: {
                type: "error",
                text: error?.message || "Change password failed"
            }
        })
    })
}

const handleChangePasswordResponse = (instance, response) => {
    const responseBody = response?.data
    if (response?.status === 200 && (!responseBody || responseBody.status === 200)) {
        instance.setState({
            ...getDefaultState(),
            flag: {
                type: "success",
                text: "Password updated"
            }
        })
        return
    }
    instance.setState({
        ...instance.state,
        saving: false,
        flag: {
            type: "error",
            text: responseBody?.message || "Change password failed"
        }
    })
}

const ChangePasswordWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        changePassword: () => changePassword(instance)
    }
}

export default ChangePasswordWorker
